import api from "../../configs/api";
import { SubscriptionPlanConsumptionDto } from "../../types";

export const getPlans = async (entity: string) => {
  try {
    const { status, data } = await api.get(`/plan/totem/${entity}`);

    if (status !== 200) throw new Error();

    return data.filter((plan: any) => plan?.status !== 3);
  } catch (error) {
    return false;
  }
};

export const createSubscriptionPlanConsumption = async (
  dto: SubscriptionPlanConsumptionDto
) => {
  try {
    const { status, data } = await api.post(
      "subscription-plan-consumption",
      dto
    );

    if (status !== 201) throw new Error();

    return data;
  } catch (error) {
    return false;
  }
};

export const getSubscriptionPlanConsumption = async () => {
  try {
    const { status, data } = await api.get("/subscription-plan-consumption/");

    if (status !== 200) throw new Error();

    return data;
  } catch (error) {
    return false;
  }
};
